export default __webpack_public_path__ + "static/media/02(2).4b6bdc5f.png";